import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconHomeSvg } from "./IconHomeSvg.mjs";
const IconHome = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconHomeSvg, ...svgProps }) });
export {
  IconHome
};
